import { useState, useEffect } from "react";
import { Fade } from "@mui/material";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import PauseIcon from "@mui/icons-material/Pause";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

const ICON_COMPONENTS = {
  mute: VolumeOffIcon,
  unmute: VolumeUpIcon,
  pause: PauseIcon,
  play: PlayArrowIcon,
};

const VideoFeedbackOverlay = ({ iconType, handleReset }) => {
  const [shouldShow, setShouldShow] = useState(false);

  useEffect(() => {
    if (!iconType) {
      return;
    }

    setShouldShow(true);

    const hideTimeout = setTimeout(() => setShouldShow(false), 800);
    return () => {
      clearTimeout(hideTimeout);
    };
  }, [iconType]);

  return (
    <Fade in={shouldShow} timeout={250} onExited={handleReset}>
      <div className="feedback-icon-container">{renderIcon(iconType)}</div>
    </Fade>
  );
};

export default VideoFeedbackOverlay;

function renderIcon(iconType) {
  const Icon = ICON_COMPONENTS[iconType];
  return Icon ? <Icon className="feedback-icon" /> : null;
}
